import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import AcademyConfigProp from '../landing/propTypes/academyConfig';
import translate from '../../commonComponents/translate';
import { throttle } from '../../services/utilityFunctions';
import SearchInput from '../../commonComponents/SearchInput';

function ShopMainHero({ t, academyConfig }) {
  const { heroImage, responsiveHeroImage, title } = academyConfig || {};
  const [useSmall, setUseSmall] = useState(false);

  const handleWindowResize = throttle(() => {
    if (window.matchMedia('(max-width: 768px)').matches) {
      setUseSmall(true);
    } else {
      setUseSmall(false);
    }
  }, 300);

  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    handleWindowResize();
    window.addEventListener('resize', handleWindowResize);

    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  const image =
    useSmall && responsiveHeroImage ? responsiveHeroImage : heroImage;

  const handleSearchChange = search => {
    setInputValue(search);

    window.location = `/shop?searchInput=${search}`;
  };

  return (
    <div
      className="shop-main-hero"
      style={{ backgroundImage: `url(${image})` }}
    >
      <div className="shop-main-slider">
        <div className="row justify-content-center">
          <div className="col-lg-7 col-md-7 col-sm-12">
            <SearchInput
              id="searchInput"
              handleTextValueChange={handleSearchChange}
              placeholder={t('search.products')}
              buttonText={t('search_button')}
              value={inputValue}
            />
          </div>
        </div>
        <div className="col-lg-8 col-md-8 col-12">
          <div className="shop-main-hero-text-box">
            <h1 className="shop-main-hero-title">{title}</h1>
            <div className="shop-main-hero-button-container mt-4">
              <a href="/shop" className="shop-main-hero-button">
                {t('shop.see_products')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ShopMainHero.propTypes = {
  t: PropTypes.func.isRequired,
  academyConfig: PropTypes.shape(AcademyConfigProp.propType).isRequired,
};

export default translate(ShopMainHero);
